module.exports = __webpack_public_path__ + "img/loading_02.ae203998.svg";